<script setup>
  import { useLoading } from '@/features/layout/components/utils/useLoading.js'
  import Spinner from '@/features/ui/components/Spinner.vue'

  const loadingStore = useLoading()
</script>

<template>
  <Transition name="fade">
    <div v-if="loadingStore.isLoading.value" class="loading-blocker">
      <slot></slot>
      <Spinner class="spinner" />
    </div>
  </Transition>
</template>

<style lang="scss" scoped>
  .loading-blocker {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.1);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
</style>
